import {
  GET_NOTIFICATION_FOR_WEBSITE_FAILURE,
  GET_NOTIFICATION_FOR_WEBSITE_REQUEST,
  GET_NOTIFICATION_FOR_WEBSITE_SUCCESS,
} from "./actionTypes";

const initialState = {
  ISlOADING: false,
  NOTIFICATIONS: [],
  ISFAILURE: false,
};

export default function NotificationReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case GET_NOTIFICATION_FOR_WEBSITE_REQUEST:
      return { ...state, ISlOADING: true };
    case GET_NOTIFICATION_FOR_WEBSITE_SUCCESS:
      return { ...state, NOTIFICATIONS: payload.data, ISlOADING: false };
    case GET_NOTIFICATION_FOR_WEBSITE_FAILURE:
      return { ...state, ISFAILURE: true, ISlOADING: false };
    default:
      return state;
  }
}
